(function () {
  // --- helpers ---
  function keyFromAltTag(alt) {
    if (!alt) return null;
    const m = String(alt).match(/\|color:([a-z0-9_-]+)\|/i);
    return m ? m[1].toLowerCase() : null;
  }

  function slugify(input) {
    if (!input) return null;
    let s = String(input).trim().toLowerCase();
    s = s
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ß/g, "ss");
    s = s.replace(/\|/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    return s || null;
  }

  function getSelectedColorLabel() {
    // Horizon: radio pills in variant-picker OR dropdown
    const picked =
      document.querySelector("variant-picker fieldset input:checked") ||
      document.querySelector("variant-picker select option[selected]");

    if (!picked) return null;

    if (picked instanceof HTMLInputElement) {
      const label = picked.closest("label");
      return (label?.textContent || picked.value || "").trim();
    }
    return (picked.textContent || "").trim();
  }

  function getSelectedColorKey() {
    // Preferred: derive from current UI label (generic, but language-dependent)
    // Best: you set |color:<key>| tags in alt-text and keep keys consistent.
    const label = getSelectedColorLabel();
    return slugify(label);
  }

  // --- main gallery ---
  function init(root) {
    const mainImg = root.querySelector(".mv-main-img");
    if (!mainImg) return;

    const more = root.querySelector("[data-mv-more]");
    const plusBtn = root.querySelector("[data-mv-plus]");
    const prevBtn = root.querySelector("[data-mv-prev]");
    const nextBtn = root.querySelector("[data-mv-next]");

    function getAllThumbImgs() {
      return Array.from(root.querySelectorAll('img[data-full]'));
    }

    // Filter thumbs by selected color key using the ALT TAG:
    // "... |color:ivory-white|"
    function getVisibleThumbImgs() {
      const key = getSelectedColorKey();
      const thumbs = getAllThumbImgs();

      // Only filter if at least one thumb has a |color:...| tag
      const anyTagged = thumbs.some(img => keyFromAltTag(img.getAttribute("alt")));
      if (!anyTagged) return thumbs;

      // If key is missing, show all (fallback)
      if (!key) return thumbs;

      return thumbs.filter(img => {
        const altKey = keyFromAltTag(img.getAttribute("alt"));
        return altKey === key;
      });
    }

    function getFullList() {
      return getVisibleThumbImgs()
        .map(img => img.getAttribute("data-full"))
        .filter(Boolean);
    }

    function currentIndex(list) {
      const cur = mainImg.getAttribute("src");
      let i = list.findIndex(u => u === cur);
      if (i === -1) i = list.findIndex(u => cur && u && cur.includes(u));
      if (i === -1) i = 0;
      return i;
    }

    function setMain(src) {
      if (!src) return;
      mainImg.src = src;
    }

    // Click handler (dynamic: works even after variant change)
    function bindThumbClicks() {
      getAllThumbImgs().forEach((img) => {
        if (img.dataset.mvBound === "1") return;
        img.dataset.mvBound = "1";

        img.addEventListener("click", () => {
          const key = getSelectedColorKey();
          const altKey = keyFromAltTag(img.getAttribute("alt"));

          // If tagged filtering is active, ignore clicks on non-matching thumbs
          const thumbs = getAllThumbImgs();
          const anyTagged = thumbs.some(t => keyFromAltTag(t.getAttribute("alt")));
          if (anyTagged && key && altKey && altKey !== key) return;

          const full = img.getAttribute("data-full");
          setMain(full);
        });
      });
    }

    bindThumbClicks();

    // Plus toggle => open/close + text change
    if (plusBtn && more) {
      const originalText = plusBtn.textContent.trim(); // e.g. "+8"
      plusBtn.addEventListener("click", () => {
        const open = more.classList.toggle("is-open");
        plusBtn.textContent = open ? "Weniger" : originalText;
      });
    }

    // Arrow navigation (only within filtered list)
    function step(dir) {
      const list = getFullList();
      if (!list.length) return;
      const i = currentIndex(list);
      const next = (i + dir + list.length) % list.length;
      setMain(list[next]);
    }

    if (prevBtn) prevBtn.addEventListener("click", () => step(-1));
    if (nextBtn) nextBtn.addEventListener("click", () => step(1));

    // On variant change: ensure main image is in the filtered list
    function syncToVariant() {
      const list = getFullList();
      if (!list.length) return;
      const cur = mainImg.getAttribute("src") || "";
      const ok = list.some(u => u === cur || (cur && u && cur.includes(u)));
      if (!ok) setMain(list[0]);
      bindThumbClicks();
    }

    document.addEventListener("variant:selected", syncToVariant);
    document.addEventListener("variant:update", syncToVariant);

    // initial sync
    syncToVariant();
  }

  function boot() {
    document.querySelectorAll(".mv-gallery").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
